import { render, staticRenderFns } from "./productcategory.vue?vue&type=template&id=a238fbea&"
import script from "./productcategory.vue?vue&type=script&lang=js&"
export * from "./productcategory.vue?vue&type=script&lang=js&"
import style0 from "./productcategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports